/**
 * The "$ building ▌" tag (2026-09-01 `design_handoff_building_tag`, variant
 * 2d "Inverted"). A terminal-flavoured chip that marks a coding session as
 * actively building RIGHT NOW: a `$` prompt glyph, a lowercase mono label,
 * and a block caret blinking on a 1s square wave.
 *
 * It is a LIVE signal, not a kind marker, which is why it renders only for
 * `running` rows — a blinking caret on a session that stopped an hour ago
 * would be a lie. Every other coding-session row keeps the quiet violet
 * "Coding session" tag, so the "this is a build, not a chat" cue is never
 * lost (Mattias, 2026-09-01).
 *
 * Colours are the app's own brand blue rather than the handoff's literals
 * (#1f5cff ink, #eef3ff fill, #cfdcff border): those are a near-miss of
 * `--eddy-blue`, and a second almost-identical blue in the same popover
 * reads as a mistake rather than a design — the same call the running ring's
 * sweep already made. Blue is also the right answer semantically here: the
 * ring turning beside this tag is `--eddy-blue` too, so a running row reads
 * as one thing. The idle tag's violet and this blue never appear on the same
 * row.
 *
 * Everything visual is `.eddy-tb-building*` in `top-bar.css` — the caret
 * needs a keyframe and a reduced-motion rule, which is a stylesheet's job.
 */
export function BuildingTag() {
  return (
    <span
      // The handoff's accessibility note: the status is exposed as text, and
      // the two decorative parts are not. The label is the accessible name,
      // so the `$` and the caret never reach a screen reader as stray
      // punctuation.
      role="status"
      aria-label="Building"
      className="eddy-tb-building"
    >
      <span aria-hidden="true" className="eddy-tb-building-prompt">
        $
      </span>
      building
      <span aria-hidden="true" className="eddy-tb-building-caret" />
    </span>
  );
}
